import React from 'react';
import { CompanyOptionStyle } from './style';
import { DeleteCompanyOption } from '../../../functions/User/deleteCompanyOption';

export default function CompanyOption({ comp, index, companiesName, companiesId, setCompaniesName, setCompaniesId }) {
  return (
    <CompanyOptionStyle>
      <p>{comp.name}</p>
      <button onClick={() => DeleteCompanyOption(index, companiesName, companiesId, setCompaniesName, setCompaniesId)}>
        remover
      </button>
    </CompanyOptionStyle>
  );
}
